import { Icon as BlueIcon } from '@blueprintjs/core';
import ProductImagePng from '@assets/png/product.png';

import ReactTooltip from 'react-tooltip';
import { IProductCreateUpdate } from '@models/Product.model';
import { useContext } from 'react';
import { CreateUpdateContext } from '@components/CreateUpdatesDialog/CreateUpdatesDialog.query';
import {
  Container,
  Text,
  Header,
  Title,
  Close,
  ProductList,
  ContentDiv,
  Wrapper,
  Row,
  ProductImage,
  CounterWrapper,
  HeaderRow,
  ClearButton,
  DeleteButton,
} from './MenuContent.styles';

interface IAddFieldContent {
  setOpenMenu: (bool: boolean) => void;
  products: IProductCreateUpdate[];
  amount: number;
}

const MenuContent = ({ setOpenMenu, amount, products }: IAddFieldContent) => {
  const { relatesTo, setSelectedProducts, selectedProducts } =
    useContext(CreateUpdateContext);

  return (
    <Container>
      <Header>
        <HeaderRow>
          <Title>Selected Items</Title>
          <CounterWrapper>{amount}</CounterWrapper>
        </HeaderRow>
        <Close
          onClick={() => {
            setOpenMenu(false);
          }}
        >
          <BlueIcon icon="cross" color="#8F95B2" />
        </Close>
      </Header>
      <ContentDiv>
        {relatesTo.value === 'products' && products && products.length > 0 ? (
          <ProductList className="manufacturer-list">
            <Row className="clear">
              <ClearButton onClick={() => setSelectedProducts([])}>
                Clear
              </ClearButton>
            </Row>
            {products.map(productItem => (
              <Wrapper>
                <Row>
                  <ProductImage src={productItem.image || ProductImagePng} />
                  <Text className="product-label" limitOfLines={1}>
                    {productItem.name}
                  </Text>
                </Row>
                <DeleteButton
                  onClick={() => {
                    setSelectedProducts(
                      selectedProducts.filter(
                        item => item.id !== productItem.id,
                      ),
                    );
                  }}
                  data-tip
                  data-for="deleteTooltip"
                >
                  <BlueIcon icon="delete" color="#8F95B2" />
                </DeleteButton>

                <ReactTooltip
                  className="tooltip"
                  id="deleteTooltip"
                  effect="solid"
                  multiline
                >
                  Delete Item
                </ReactTooltip>
              </Wrapper>
            ))}
          </ProductList>
        ) : (
          <Text className="description">No product selected</Text>
        )}
      </ContentDiv>
    </Container>
  );
};

export { MenuContent };
